export default class BookingMemberToEventPriceDefinition {
    id: number
    bookingMemberId: number
    eventPriceDefinitionId: number
}